import { Button, IconButton, Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useDynamicList, useUpdateEffect } from "ahooks";
import { IconTrash } from "@/components/Icon";
import { useTranslation } from "@/langs/useTranslation";
import UserSelector from "@/components/CompanyTree/UserSelector";
import { uniqueObjectArray } from "@/helpers/utils";

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 4,
    overflow: "hidden",
    border: "1px solid #E9E8ED",
    marginTop: theme.spacing(2)
  },
  header: {
    backgroundColor: "#F8F9FC"
  },
  item: {
    display: "flex",
    alignItems: "center",

    "&:not(:last-child)": {
      borderBottom: "1px solid #E9E8ED"
    },
    "& > div": {
      padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
      display: "flex",
      alignItems: "center"
    },
    "& > div:nth-child(1)": {
      flex: 1
    },
    "& > div:nth-child(2)": {
      flex: 1
    },
    "& > div:nth-child(3)": {
      flex: 1.5
    }
  }
}));

const Header = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={clsx(classes.item, classes.header)}>
      <div>{t({ defaultMessage: "姓名" })}</div>
      <div>{t({ defaultMessage: "邮箱" })}</div>
      <div>{t({ defaultMessage: "手机号" })}</div>
    </div>
  );
};

const Item = ({ index, disabled, item, remove }) => {
  const classes = useStyles();

  return (
    <div className={classes.item}>
      <Typography variant="body2" component="div">
        {item.name}
      </Typography>
      <Typography variant="body2" component="div">
        {item.email}
      </Typography>
      <div>
        <Typography variant="body2" component="span" style={{ flex: 1 }}>
          {item.phone}
        </Typography>
        {!disabled && (
          <IconButton style={{ float: "right" }} onClick={() => remove(index)}>
            <IconTrash color="secondary" size={14} />
          </IconButton>
        )}
      </div>
    </div>
  );
};

const AlarmNotifyUsers = ({ disabled, name, value = [], onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { list, getKey, resetList, remove } = useDynamicList(value);

  const handleConfirm = (userIds, users) => {
    resetList(
      uniqueObjectArray(
        [
          ...value,
          ...users.map(user => ({
            id: user.id,
            name: user.name,
            email: user.email,
            phone: user.phone
          }))
        ],
        "id"
      )
    );
  };

  useUpdateEffect(() => {
    onChange?.({ target: { name, value: list } });
  }, [list]);

  return (
    <>
      <UserSelector
        checkedKeys={value.map(item => item.id)}
        onConfirm={handleConfirm}
      >
        <Button color="primary" variant="contained" disabled={disabled}>
          {t({ defaultMessage: "添加成员" })}
        </Button>
      </UserSelector>
      <div className={classes.root}>
        <Header />
        {list.map((item, index) => (
          <Item
            key={getKey(index)}
            disabled={disabled}
            index={index}
            item={item}
            remove={remove}
          />
        ))}
      </div>
    </>
  );
};

export default AlarmNotifyUsers;
